import { MDBIcon } from "mdb-react-ui-kit";
import React from "react";
import { toast } from "react-toastify";
import { useDarkMode } from "../assets/DarkModeContext";
import { http } from "../services/httpService";

export default function CompetenceItem(
    {
        item,
        categories,
        selectedLanguage,
        setEditingCompetence,
        setCompetences,
    } ) {

    const { isDarkMode } = useDarkMode();

    const handleEditClick = ( competence ) => {
        setEditingCompetence( competence.id );
    };

    const handleDeleteClick = async ( competence ) => {
        const confirmDelete =  window.confirm( "Êtes-vous sûr de vouloir supprimer cette compétence ?" );

        if ( confirmDelete ) {
            try {
                const response = await http( `ref/competences/${ competence.id }`, {
                    method: 'DELETE',
                } );

                if ( !response.ok ) {
                    throw new Error( `Error: ${ response.status }` );
                }

                setCompetences( prevState =>
                    prevState.filter( c => c.id !== competence.id )
                );

                toast.success( "Compétence supprimée avec succès" );
            } catch ( error ) {
                console.error( 'There was an error deleting the competence:', error );
                toast.error( "Erreur lors de la suppression de la compétence, cette compétence est déjà utilisée" );
            }
        }
    };

    const itemCategory = categories.find( (cat => cat.id === item.categoryId));

    return (
        <tr className={ `${ isDarkMode ? 'text-white' : '' }` }>
            <td>
                { itemCategory ? itemCategory.translations[ selectedLanguage ] : 'Sans categorie' }
            </td>
            <td>
                { item.competenceTranslations[ selectedLanguage ] || '-' }
            </td>
            <td>
                { item.descriptionTranslations[ selectedLanguage ] || '-' }
            </td>
            <td>
                <MDBIcon fas icon="edit" className='text-info'
                         onClick={ () => handleEditClick( item ) }/>
                <MDBIcon fas icon="trash-alt" className='ms-3 text-info'
                         onClick={ () => handleDeleteClick( item ) }/>
            </td>
        </tr>
    );
}